<div class="flex h-7 items-center justify-between mb-5">
  <div class="text-[1.125rem] leading-7 font-bold text-font-primary">Create Adjustment Transaction</div>
  <button
    appRemoveFocus
    class="p-2 text-2xl text-secondary rounded-full transition-colors hover:bg-gray-100"
    title="Close"
    (click)="activeModal.close()"
  >
    <rkt-icon name="times" />
  </button>
</div>

<form [formGroup]="transactionAdjustmentForm">
  <rkt-form [form]="transactionAdjustmentForm" [fields]="formFields" [model]="formModel" />
</form>

@if (formSubmitError) {
  <div class="error-container">
    <div class="separator"></div>
    <div class="details-page-edit-form-error">{{ formSubmitError }}</div>
  </div>
}

<div class="buttons">
  <button rktButton btnType="tertiary" (click)="activeModal.close()">Cancel</button>
  <button rktButton title="Create" [disabled]="isLoading || transactionAdjustmentForm.invalid" (click)="onCreate()">Create</button>
</div>
